module.exports = __webpack_public_path__ + "img/MEDIA117.bfd9c7f3.jpg";